module.exports = __webpack_public_path__ + "img/tally-2.16f761c7.svg";